import { byRegion } from 'app/shared-components/region';

export interface OnboardingStep {
  id?: 'preview';
  label: string;
  title: string;
  description: string;
  icon: string;
  need?: string;
}

// en-CA keeps -our spellings (colour) but takes -ize.
const CUSTOMISE = byRegion({ uk: 'customise', canada: 'customize' });
const CUSTOMISED = byRegion({ uk: 'customised', canada: 'customized' });

// Rendered by the home page step against the builder option, so it follows the same rule as the
// step copy below rather than carrying its own hardcoded spelling.
export const HOME_PAGE_BUILDER_BLURB = `Build and ${CUSTOMISE} your landing page with our drag-and-drop editor.`;

// Canada's websites don't carry on-site bookings or payments, so the parity
// promise is scoped to the journeys it does have.
const HOME_PAGE_PARITY = byRegion({
  uk: 'bookings, payments and your profile',
  canada: 'the user journeys and your profile',
});

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    label: 'Step 1: Brand colour',
    title: 'Pick your brand colour',
    description: 'Sets the look and feel of your entire site',
    icon: '/assets/images/plus-websites/icon-colour.svg',
    need: 'Your brand hex code, or just pick a colour from the palette. You can always update it later.',
  },
  {
    label: 'Step 2: Logo',
    title: 'Upload your logo',
    description: 'Appears in the header and across your site',
    icon: '/assets/images/plus-websites/icon-logo.svg',
    need: 'A PNG or SVG file with a transparent background. Recommended size: at least 300px wide.',
  },
  {
    id: 'preview',
    label: 'Preview',
    title: 'Preview your website',
    description: `What's included in the demo and what can be ${CUSTOMISED} in the future`,
    icon: '/assets/images/plus-websites/icon-preview.svg',
  },
  {
    label: 'Step 3: Home page',
    title: 'Where should visitors land?',
    description: 'Use our page or bring your own',
    icon: '/assets/images/plus-websites/icon-home.svg',
    need: `Choose our built-in page or enter your existing site URL. Either way, ${HOME_PAGE_PARITY} will work the same.`,
  },
  {
    label: 'Step 4: Domain',
    title: 'Set up your domain',
    description: 'The web address where your site will live',
    icon: '/assets/images/plus-websites/icon-domain.svg',
    need: "If you have your own domain, keep your login details for your domain provider handy. No domain yet? We'll assign you a free subdomain to get started.",
  },
];
